import getHeaderHeight from './getHeaderHeight'

/**
 * Make the results grid scroll to the highlighted item.
 */
export default function scrollToHighlight() {
    const grid = /** @type {HTMLElement} */ (document.getElementById('search-results-grid'))
    const highlightItem = /** @type {HTMLElement} */ (grid.querySelector('li.highlight'))

    if (!highlightItem) return // nothing to scroll to

    /** Height of the header to subtract from the view height */
    const headerHeight = getHeaderHeight()
    /** Bounds of the highlighted item relative to the current viewport */
    const highlightItemBounds = highlightItem.getBoundingClientRect()
    /** Current scroll position of the page */
    const currentScrollTop = document.documentElement.scrollTop

    // Now we scroll the item into view
    if (highlightItemBounds.top < headerHeight) {
        // Highlight item is (partly) above the visible area, so we scroll up
        document.documentElement.scrollTop = currentScrollTop + highlightItemBounds.top - headerHeight
    } else if (highlightItemBounds.bottom > window.innerHeight) {
        // Highlight item is (partly) below the visible area, so we scroll down
        const pagination = document.querySelector('.pagination')
        /** View height to calculate with, respecting the pagination potentially occupying some space */
        const viewHeight = pagination ? window.innerHeight - pagination.clientHeight : window.innerHeight
        document.documentElement.scrollTop = currentScrollTop - viewHeight + highlightItemBounds.bottom
    }
}
